function moveSlide(button, direction) {
    const track = button.parentElement.querySelector('.slider-track');
    const slides = track.querySelectorAll('img');
    const totalSlides = slides.length;
    
    let currentIndex = parseInt(track.dataset.index || 0);
    
    currentIndex += direction;
    
    if (currentIndex >= totalSlides) {
        currentIndex = 0;
    } else if (currentIndex < 0) {
        currentIndex = totalSlides - 1;
    }
    
    track.dataset.index = currentIndex;
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
}

document.querySelectorAll('.swatch').forEach(swatch => {
    swatch.addEventListener('click', function() {
        this.parentElement.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
        this.classList.add('active');
    });
});